<section class="hero" role="region">
  <header role="banner" class="hero__header">
    <h1 class="hero__header__title">{{ title }}</h1>
    <p class="hero__header__content">{{ content }}</p>
  </header>
  <img
    [src]="illustrationSrc | imaginarySrc: 1:493"
    [srcset]="illustrationSrc | imaginarySrc: 4:493"
    class="hero__illustration"
    alt=""
    loading="lazy"
  />
</section>
